var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRespondgamingGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35.7 35.7",
    style: {
      enableBackground: "new 0 0 35.7 35.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.094947e-13,
    y1: 17.8535,
    x2: 35.707,
    y2: 17.8535,
    gradientTransform: "matrix(6.123234e-17 1 -1 6.123234e-17 35.707 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D9E021"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009245"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M0,20.1v-4.5c0-1.3,1.1-2.3,2.3-2.3h1.5c0.2-0.7,0.5-1.4,0.9-2.1l-1.1-1.1 c-0.9-0.9-0.9-2.4,0-3.3l3.2-3.2C7.3,3.2,7.8,3,8.5,3c0.6,0,1.2,0.2,1.7,0.7l1.1,1.1c0.7-0.3,1.4-0.6,2.1-0.9V2.3 c0-1.3,1.1-2.3,2.3-2.3h4.5c1.3,0,2.3,1.1,2.3,2.3v1.5c0.7,0.2,1.4,0.5,2.1,0.9l1.1-1.1C26,3.2,26.6,3,27.2,3 c0.6,0,1.2,0.2,1.7,0.7l3.2,3.2c0.9,0.9,0.9,2.4,0,3.3L31,11.2c0.3,0.7,0.6,1.4,0.9,2.1h1.5c1.3,0,2.3,1.1,2.3,2.3v4.5 c0,1.3-1.1,2.3-2.3,2.3h-1.5c-0.2,0.7-0.5,1.4-0.9,2.1l1.1,1.1c0.9,0.9,0.9,2.4,0,3.3l-3.2,3.2c-0.4,0.4-1,0.7-1.7,0.7 c-0.6,0-1.2-0.2-1.7-0.7L24.5,31c-0.7,0.3-1.4,0.6-2.1,0.9v1.5c0,1.3-1.1,2.3-2.3,2.3h-4.5c-1.3,0-2.3-1.1-2.3-2.3v-1.5 c-0.7-0.2-1.4-0.5-2.1-0.9l-1.1,1.1c-0.4,0.4-1,0.7-1.7,0.7c-0.6,0-1.2-0.2-1.7-0.7l-3.2-3.2c-0.9-0.9-0.9-2.4,0-3.3l1.1-1.1 c-0.3-0.7-0.6-1.4-0.9-2.1H2.3C1.1,22.4,0,21.4,0,20.1z M2.8,16.1v3.6H6l0.3,1.1C6.6,21.9,7,23,7.6,24L8.2,25l-2.3,2.3l2.5,2.5 l2.3-2.3l0.9,0.6c1,0.6,2.1,1.1,3.3,1.4l1.1,0.3v3.2h3.6v-3.2l1.1-0.3c1.2-0.3,2.3-0.7,3.3-1.4l0.9-0.6l2.3,2.3l2.5-2.5L27.5,25 l0.6-0.9c0.6-1,1.1-2.1,1.4-3.3l0.3-1.1h3.2v-3.6h-3.2L29.4,15c-0.3-1.2-0.7-2.3-1.4-3.3l-0.6-0.9l2.3-2.3l-2.5-2.5L25,8.2L24,7.6 c-1-0.6-2.1-1.1-3.3-1.4L19.6,6V2.8h-3.6V6L15,6.3c-1.2,0.3-2.3,0.7-3.3,1.4l-0.9,0.6L8.5,5.9L5.9,8.5l2.3,2.3l-0.6,0.9 c-0.6,1-1.1,2.1-1.4,3.3L6,16.1H2.8z M9.8,17.9c0-4.5,3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1s-3.6,8.1-8.1,8.1S9.8,22.3,9.8,17.9z  M23.1,17.9c0-2.9-2.4-5.3-5.3-5.3s-5.3,2.4-5.3,5.3s2.4,5.3,5.3,5.3S23.1,20.8,23.1,17.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespondgamingGreen);
export default __webpack_public_path__ + "static/media/respondgaming_green.9669b61eeda19504f9766885aca1f804.svg";
export { ForwardRef as ReactComponent };